import React from "react"

const Header = () => {
    return <React.Fragment>
        <div
            className="col-md-12"
            style={{
                backgroundColor: "white",
                textAlign: "left",
                borderBottom: "2px solid #ccc",
                backgroundColor: "white",
                paddingTop: "5px",
                paddingBottom: "5px",
            }}
        >
            <img alt="IPCS" style={{ height: "70px" }} src={`/assets/Img/logo.png`} />
        </div>
        <div className="col-md-12 d-flex align-items-center justify-content-center">
            <h2 className="mb-0 text-black text-uppercase p-1">
                NEXT GENERATION HUMAN RESOURCE ONBOARDING, CONTRACT, TIME LOG AND INVOICING SYSTEM
            </h2>
        </div>
        <div className="col-md-12"
            style={{
                backgroundImage: `URL("/assets/Img/slide3.jpg")`,
                backgroundPosition: "center center",
                borderTop: "2px solid white",
                backgroundSize: "100%",
                color: "white",
                height: "70px",
                backgroundColor: "black",
            }}
        >
            <div className="d-flex align-items-center justify-content-center">
                <h2 className="text-white mb-1">
                    Welcome to
                </h2>
                <img className="mb-2 ml-2" alt="Workfinity" style={{ height: "23px" }} src="/assets/Img/logo_ft.png" />
            </div>
            <p className="text-white d-flex align-items-center justify-content-center mb-1 mr-4">
                <b>Workbench Portal</b>
            </p>
        </div>


    </React.Fragment >
}

export default Header;